module.exports = __webpack_public_path__ + "static/media/10、国务院国资委中央企业PPP业务专项检查咨询-min.82732794.jpg";